import React from "react";
import { IAutomobileDriverInformation } from "../../../../../../../redux/automobileDriver/automobileDriver.types";
import { RightPanel } from "../../../../../../../components/RightPanel";
import { AutomobileDriverInformation } from "./AutomobileDriverInformation";

interface IAutomobileDriverRightPanelProps {
  open: boolean;
  customerId?: number;
  customerPolicyId?: number;
  driverNumber?: number;
  onSaveSuccess: (driver: IAutomobileDriverInformation) => void;
  staticStatusValue?: string;
  created_from?: string;
  readonly?: boolean;
  onClose: () => void;
  initialData?: IAutomobileDriverInformation;
  disableApiCalls?: boolean;
  // Optional z-index for the underlying drawer. Used when this panel is opened
  // on top of another modal (e.g. the Multiple Change dialog) so it renders
  // above it instead of behind it. Defaults to the drawer's normal stacking.
  zIndex?: number;
}

export const AutomobileDriverRightPanel: React.FC<
  IAutomobileDriverRightPanelProps
> = (props) => {
  const {
    customerId,
    customerPolicyId,
    driverNumber,
    onClose,
    onSaveSuccess,
    readonly,
    staticStatusValue,
    created_from,
    initialData,
    disableApiCalls,
    zIndex,
  } = props;

  return (
    <>
      <RightPanel
        heading="Driver Information"
        //subHeading="Add notes or comments"
        open={true}
        onClose={onClose}
        width="90%"
        drawerProps={zIndex ? { zIndex } : undefined}
      >
        <AutomobileDriverInformation
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          driverNumber={driverNumber}
          onSaveSuccess={onSaveSuccess}
          readOnly={readonly}
          fromRightPanel
          staticStatusValue={staticStatusValue}
          created_from={created_from}
          initialData={initialData}
          disableApiCalls={disableApiCalls}
        />
      </RightPanel>
    </>
  );
};
